import {
  clearPendingPromotionCode,
  normalizePendingPromotionCode,
  readPendingPromotionCode,
} from '../pendingPromotionCode'

const API = import.meta.env.VITE_API_URL || ''

async function readJson(response, fallback) {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data?.error ?? fallback)
  return data
}

async function postPromotion(action, input, fallback) {
  const response = await fetch(`${API}/api/referral-promotions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ action, ...input }),
  })
  return readJson(response, fallback)
}

export async function validatePromotionCode(code) {
  const params = new URLSearchParams({ code })
  const response = await fetch(`${API}/api/referral-promotions?${params.toString()}`, {
    credentials: 'include',
  })
  return readJson(response, 'Unable to validate promotion code')
}

export async function getMyPromotionState() {
  const response = await fetch(`${API}/api/referral-promotions`, {
    credentials: 'include',
  })
  return readJson(response, 'Unable to load referral rewards')
}

export async function getPromotionAdminState() {
  const params = new URLSearchParams({ scope: 'admin' })
  const response = await fetch(`${API}/api/referral-promotions?${params.toString()}`, {
    credentials: 'include',
  })
  return readJson(response, 'Unable to load promotion admin state')
}

export async function redeemPromotionCode(code, claimSource = 'app') {
  const result = await postPromotion(
    'redeem',
    { code, claim_source: claimSource },
    'Unable to redeem promotion code',
  )
  if (readPendingPromotionCode() === normalizePendingPromotionCode(code)) {
    clearPendingPromotionCode()
  }
  return result
}

export function createPromotionCampaign(input) {
  return postPromotion('create_campaign', input, 'Unable to create promotion campaign')
}

export function issuePromotionCode(input) {
  return postPromotion('issue_code', input, 'Unable to issue promotion code')
}

export function activatePromotionCampaign(input) {
  return postPromotion('activate_campaign', input, 'Unable to activate promotion campaign')
}

export function recordPromotionConversion(input) {
  return postPromotion('record_conversion', input, 'Unable to record promotion conversion')
}

export function releasePendingPromotionRewards(input) {
  return postPromotion('release_pending', input, 'Unable to release pending promotion rewards')
}
